import React from 'react';
import { useLocation } from 'react-router-dom';
import Matches from '../components/Matches';

// Helper to get cache object from localStorage
function getCache(key) {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : null;
    const data = parsed && typeof parsed === 'object' && 'data' in parsed ? parsed.data : parsed;
    if (!data) return { data: null, lastFetched: null };
    try {
        if (data && typeof data === 'object' && 'data' in data && 'lastFetched' in data) {
            return data;
        } else {
            // Backward compatibility: treat as data only
            return { data: data, lastFetched: null };
        }
    } catch {
        return { data: null, lastFetched: null };
    }
}

const MyMatches = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const initialTab = params.get('tab') || 'singles';
    const storedProfile = getCache('userProfile').data || {};
    const userId = storedProfile?.userId || null;

    return <Matches userId={userId} title="My matches for location" cacheKeyPrefix="user" initialTab={initialTab} />;
};

export default MyMatches;